import React from 'react';
import { connect } from 'react-redux';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import moment from 'moment-jalaali';
import { ICompanies, ITasks, RootState } from 'store/store';
import Modal from 'components/Modal';
import TasksListContainer from 'containers/Tasks/TasksManagement/TasksListContainer';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import TaskEditorStack from '../../../containers/Tasks/TasksManagement/TaskEditorStack';
import i18n from '../../../i18n';
import { ILocal } from '../../Chart/BaseDatePicker';

moment.loadPersian({ dialect: 'persian-modern' });

export interface ITaskReportModalProps {
  tasks: ITasks;
  companies: ICompanies;
  thisUser: IThisUserState;
  templateId?: number;
  startDate: number;
  endDate: number;
  onClose: () => void;
  assigneeId?: number;
  projectId?: number;
  companyId: number;
  parentId?: number;
  ancestorId?: number;
  searchParams: any;
  fieldValues: { [key: string]: string };
  local: ILocal;
}

export interface ITaskReportModalState {
  loading: boolean;
  showTaskEditor: boolean | number;
}

const TasksWrapper = styled.section`
  flex: 1;
  width: 100%;
  display: block;
  min-height: 0;

  & > div {
    box-shadow: none;
    border-radius: 0.5rem;
  }

  & h3 {
    display: none;
  }
`;

class TaskReportModal extends React.PureComponent<
  ITaskReportModalProps,
  ITaskReportModalState
> {
  state: ITaskReportModalState = {
    loading: false,
    showTaskEditor: false,
  };

  onCloseModal = () => {
    this.props.onClose();
  };

  handleShowTaskEditor = (taskId?: number | 'new') => {
    // if taskId is not exist we should show a task editor for task task creation
    this.setState({
      showTaskEditor: taskId ? (taskId as number) : true,
    });
  };

  handleHideTaskEditor = () => {
    this.setState({ showTaskEditor: false });
  };

  closeTaskEditor = () => {
    this.setState({
      showTaskEditor: false,
    });
  };

  render() {
    const {
      projectId,
      companyId,
      templateId,
      startDate,
      endDate,
      assigneeId,
      parentId,
      ancestorId,
      searchParams,
      fieldValues,
      local,
    } = this.props;

    const endOfMonth =
      local === 'fa_IR@calendar=persian'
        ? moment(endDate).endOf('jMonth').valueOf()
        : moment(endDate).locale('en').endOf('month').valueOf();

    return createPortal(
      <Modal
        isActive={true}
        title={i18n.t('relatedTasks', { ns: 'taskManager' })}
        onClose={this.onCloseModal}
        width="90%"
      >
        <TasksWrapper>
          <TasksListContainer
            taskSelected={this.state.showTaskEditor}
            projectId={projectId}
            companyId={companyId}
            onOpenTaskEditor={this.handleShowTaskEditor}
            withFewerOptions={true}
            templateId={templateId}
            startDate={startDate}
            endDate={endOfMonth}
            assigneeId={assigneeId}
            parentId={parentId}
            ancestorId={ancestorId}
            reportParams={searchParams}
            archivedDefault={true}
            fieldValues={fieldValues}
            includeDrafted={false}
            local={local}
            isModal={true}
          />
          {this.state.showTaskEditor && (
            <TaskEditorStack
              taskLeftOffset={10}
              companyId={companyId}
              onCloseTask={this.handleHideTaskEditor}
              projectId={projectId || 0}
              embedded={true}
              handleChangeTaskInplace={(taskId: number) => {
                this.setState({ showTaskEditor: taskId });
              }}
              hideParents={true}
              taskId={
                typeof this.state.showTaskEditor === 'number'
                  ? this.state.showTaskEditor
                  : 0
              }
            />
          )}
        </TasksWrapper>
      </Modal>,
      document.body
    );
  }
}

const mapStateToProps = (state: RootState) => {
  const tasks = state.tasks.data;
  const companies = state.companies.data;
  const thisUser = state.thisUser;

  return { tasks, companies, thisUser };
};

// @ts-expect-error it's ok
export default connect(mapStateToProps)(TaskReportModal);
